import {
    Box,
    Typography,
} from '@mui/material';

function LegendItem({ label, color }) {
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px'}}>
                <Box sx={{ width: '20px', height: '20px', borderRadius: '10px', backgroundColor: color }}></Box>
                <Typography>{label}</Typography>
            </Box>
        </>
    );
};

export default LegendItem
